import MojitoCore from 'mojito/core';
import MojitoPresentation from 'mojito/presentation';

const UIViewImplementation = MojitoCore.Presentation.UIViewImplementation;
const BettingHelper = MojitoPresentation.Utils.BettingHelper;

export default class PotentialReturns extends UIViewImplementation {
    render() {
        return (
            <div style={this.style.container} className="PotentialReturns ta-PotentialReturns">
                <div
                    style={this.props.disabled ? this.style.labelDisabled : this.style.label}
                    className="PotentialReturns-label ta-PotentialReturnsLabel"
                >
                    {this.resolveString(
                        this.props.hasAccaBoost
                            ? '$BETSLIP.POTENTIAL_WITH_ACCA_BOOST'
                            : '$BETSLIP.POTENTIAL'
                    )}
                </div>
                <div
                    style={this.props.disabled ? this.style.disabled : this.style.base}
                    className="PotentialReturns-value ta-PotentialReturnsValue"
                >
                    {BettingHelper.formatPayout(
                        this.props.potentialReturns,
                        this.resolveString('$BETSLIP.NOT_AVAILABLE'),
                        this.props.currencyCode
                    )}
                </div>
            </div>
        );
    }
}

PotentialReturns.getStyle = function (config, applicationMode, merge) {
    const { style } = config;
    return {
        container: {
            justifyContent: 'flex-end',
            display: 'flex',
            alignItems: 'center',
        },
        label: merge(style.label, style.label.textStyle),
        labelDisabled: merge(style.labelDisabled, style.labelDisabled.textStyle),
        base: merge(style.base, style.base.textStyle),
        disabled: merge(style.disabled, style.disabled.textStyle),
    };
};
